import { List, Create, Edit } from "../Components/index.js";

export default [
    {
        path: "/admin/units",
        component: List,
        name: "units-list",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/units/:id/edit",
        component: Edit,
        name: "units-edit",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/units/create",
        component: Create,
        name: "units-create",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/admin/units/copy-cadre/:unit_id",
        component: Create,
        name: "units-copy-cadre",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/admin/units/copy-rank/:unit_id",
        component: Create,
        name: "units-copy-rank",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/admin/units/copy-appt/:unit_id",
        component: Create,
        name: "units-copy-appt",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/admin/units/copy-company/:unit_id",
        component: Create,
        name: "units-copy-company",
        meta: {
            requiresAuth: true,
        },
    },
];
